//External
import React, { useEffect, useState } from "react";
import Link from "next/link";
import ReactHtmlParser from "react-html-parser";
import ShowMore from "react-show-more";
import { Button } from "react-bootstrap";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import moment from "moment"; // Import moment library
//Internal
import Breadcrumbs from "../breadcrumbs/breadcrumbs";
import CarPriceBox from "../car-price-box";
import CarSlider from "../../components/car-details-slider";
// Import directly, not from the components/cards barrel - see the note in
// components/thespecials/index.js for why (barrel eagerly loads Stripe.js).
import OfferCard from "components/cards/offer-card";
import tooltip from "../../public/assets/images/tooltip.svg";

// Images
import {
  ALREADY_SAVED_WISHLIST,
  breakDown,
  formatMoney,
  get_cookie,
  hrefURL,
  minimumDayErrorMessage,
  REMOVED_WISHLIST,
  SAVED_WISHLIST,
  setBrandCategoryListAsUserBehaviour,
  setRecentlyViewVehicles,
  setRecentSearch,
  set_cookie,
  remove_cookie,
  storeLastVisitedVehicleSlug,
} from "utils";
import BreakDownModal from "components/modals/breakDownModal";
import DateRangePicker from "components/date-range";
import {
  getAddressInfo,
  getAvailableSlot,
  getVehicalDetailData,
  setShowOtpBlock,
} from "store/actions";
import SocialShareModel from "components/socialshare/socialShareModel";
import LoginModal from "../modals/loginModal";

import { addUserFavorite } from "store/actions/userfavorite";
import SuccessPopup from "components/modals/success-popup";
import {
  resetVehicleAvailableForDriveNow,
  setVehicleAvailableForDriveNow,
} from "store/reducers/vehicle";
import CommonInfoModal from "components/modals/commonInfoModal";
import { ButtonLoader } from "components/loader/ButtonLoader";
import ManualTooltip from "components/mannualTooltip";

const Vehicle = ({ vehicalDetailData, slug1, slug2 }) => {
  const router = useRouter();
  const user = useSelector((state) => state?.user);
  const [loaders, setLoaders] = useState(false)
  const [favId, setFavId] = useState(0);
  // const [showMessageModal, setShowMessageModal] = useState(false);
  const stateObj = [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ];

  const [activeId, setActiveId] = useState(null);
  const [isShowCalendar, setIshowCalendar] = useState(false);
  const [dateObj, setDateObj] = useState(stateObj);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDateMobile, setStartDateMobile] = useState("");
  const [endDateMobile, setEndDateMobile] = useState("");
  const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(true);
  const [isReserveEnable, setIsReserveEnable] = useState(true);

  const [breakDownObj, setBreakDownObj] = useState({});
  const [startDateTimeOptions, setStartDateTimeOptions] = useState([]);
  const [endDateTimeOptions, setEndDateTimeOptions] = useState([]);
  const [startTimeDefaultValue, setStartTimeDefaultValue] = useState(null);
  const [endTimeDefaultValue, setEndTimeDefaultValue] = useState(null);
  const [minDayErrorMessage, setMinDayErrorMessage] = useState("");
  const [globalSetting, setGlobalSetting] = useState({});
  const [minimumDay, setMinimumDay] = useState(1);
  const [isMobileScreen, setIsMobileScreen] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const handleCloseBreakDown = () => setShowModal(false);
  const handleShowBreakDown = () => setShowModal(true);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [securityDepositModal, setShowSecurityModal] = useState(false)
  const minDays = vehicalDetailData?.vehicle?.minimum_days || 1;
  const dayLabel = minDays > 1 ? "days" : "day";
  const handleInfoClose = () => {
    if (showInfoModal) {
      setShowInfoModal(false);
    } else if (securityDepositModal) {
      setShowSecurityModal(false)
    }
  };
  const handleInfoShow = (value) => {
    if (value === "minimumDays") {
      setShowInfoModal(true);
    } else if (value === "deposit") {
      setShowSecurityModal(true)
    }
  }
  const [clickOnFavorite, setClickOnFavorite] = useState(0);
  const [addOnClass, setAddOnClass] = useState("hide");
  const [favUnFavMessage, setFavUnFavMessage] = useState("");
  const [isSaved, setIsSaved] = useState(false);
  const [isMobileApp, setIsMobileApp] = useState("");

  const dispatch = useDispatch();
  /*******************
  @purpose : Get global settings
  @Parameter : {}
  @Author : INIC
  ******************/
  useEffect(() => {
    dispatch(getAddressInfo(get_cookie("currentLocationId"), false)).then(
      (res) => {
        setGlobalSetting(res);
      }
    );
    setIsMobileApp(get_cookie("is_mobile_app"));
  }, []);

  // When url change all variable will set default value
  useEffect(() => {
    // setActiveId("");
    setIshowCalendar(false);
    setDateObj(stateObj);
    setStartDate(null);
    setEndDate(null);
    setIsFirstTimeLoad(true);
    setIsReserveEnable(true);
    setBreakDownObj({});
    setStartDateTimeOptions([]);
    setEndDateTimeOptions([]);
    setStartTimeDefaultValue();
    setEndTimeDefaultValue();
    setMinimumDay(
      vehicalDetailData?.vehicle?.minimum_days
        ? vehicalDetailData?.vehicle?.minimum_days
        : 1
    );
    setClickOnFavorite(0);
    if (user?.token) {
      // call vehicle detail api
      dispatch(
        getVehicalDetailData(
          vehicalDetailData?.vehicle?.location_id,
          vehicalDetailData?.vehicle?.slug,
          vehicalDetailData?.vehicle?.brand_detail?.slug,
          vehicalDetailData?.vehicle?.category_detail?.slug
        )
      ).then((res) => {
        setFavId(res?.vehicle?.is_favourite);
      });
    }

    // recent search logic start here
    let slugUrl = hrefURL(
      vehicalDetailData?.vehicle?.brand_detail?.slug +
      "/" +
      vehicalDetailData?.vehicle?.category_detail?.slug +
      "/" +
      vehicalDetailData?.vehicle?.slug +
      "/" +
      vehicalDetailData?.vehicle?.slug_id
    );
    let infoObj = {
      label: vehicalDetailData?.vehicle?.name_with_brand,
      image: vehicalDetailData?.vehicle?.all_images["0"].image.thumb,
      slugUrl: slugUrl,
      type: "vehical",
    };
    setRecentSearch(infoObj);
    // recent search logic end here

    // recently viewed car code start here
    setRecentlyViewVehicles(vehicalDetailData?.vehicle);
    // recently viewed car code end here

    // Set brand and category in local storage start here
    if (vehicalDetailData?.vehicle?.similar_brand_detail) {
      vehicalDetailData?.vehicle?.similar_brand_detail
        .reverse()
        .forEach((row) => {
          setBrandCategoryListAsUserBehaviour(row.slug, "brand");
        });
    }

    setBrandCategoryListAsUserBehaviour(
      vehicalDetailData?.vehicle?.brand_detail?.slug,
      "brand"
    );

    if (vehicalDetailData?.vehicle?.similar_category_detail) {
      vehicalDetailData?.vehicle?.similar_category_detail.forEach((row) => {
        setBrandCategoryListAsUserBehaviour(row.slug, "category");
      });
    }

    setBrandCategoryListAsUserBehaviour(
      vehicalDetailData?.vehicle?.category_detail?.slug,
      "category"
    );
    // Set brand and category in local storage end here

    // Set vehicle slug in local storage start here
    storeLastVisitedVehicleSlug(vehicalDetailData?.vehicle?.slug);
    // Set vehicle slug in local storage end here

    // set drive now status in redux code start here
    if (vehicalDetailData?.vehicle?.drive_now_status) {
      dispatch(setVehicleAvailableForDriveNow());
    } else {
      dispatch(resetVehicleAvailableForDriveNow());
    }
    // drive now status redux code start here
  }, [vehicalDetailData?.vehicle]);

  const handleClick = (id) => {
    if (id == 1) {
      if (
        typeof document.getElementById("descriptionParent") != "undefined" &&
        document.getElementById("descriptionParent") != null
      ) {
        document.getElementById("descriptionParent").classList.toggle("active");
      }
      if (
        typeof document.getElementById("featureParent") != "undefined" &&
        document.getElementById("featureParent") != null
      ) {
        document.getElementById("featureParent").classList.remove("active");
      }
    } else {
      if (
        typeof document.getElementById("featureParent") != "undefined" &&
        document.getElementById("featureParent") != null
      ) {
        document.getElementById("featureParent").classList.toggle("active");
      }

      if (
        typeof document.getElementById("descriptionParent") != "undefined" &&
        document.getElementById("descriptionParent") != null
      ) {
        document.getElementById("descriptionParent").classList.remove("active");
        document.getElementById("descriptionParent").scrollIntoView();
      }
    }
  };

  /*******************
  @purpose : Set start date and end date in respective fields
  @Parameter : {dateObj}
  @Author : INIC
  ******************/
  const setStartEndDateOnChange = (dateObj) => {
    setIsFirstTimeLoad(false);
    setMinDayErrorMessage("");
    setEndTimeDefaultValue(null)
    setStartTimeDefaultValue(null)
    if (
      dateObj &&
      Object.keys(dateObj).length === 0 &&
      Object.getPrototypeOf(dateObj) === Object.prototype
    ) {
      setDateObj(stateObj);
      setStartDate(null);
      setEndDate(null);
      setStartDateMobile("");
      setEndDateMobile("");
    } else {
      setDateObj([dateObj]);
      setStartDate(format(dateObj.startDate, "MMM d, yyyy", {}));
      setEndDate(format(dateObj.endDate, "MMM d, yyyy", {}));
      setStartDateMobile(format(dateObj.startDate, "MMM d", {}));
      setEndDateMobile(format(dateObj.endDate, "MMM d", {}));
    }
  };

  /*******************
  @purpose : Show error message which get by date range picker component
  @Parameter : {message}
  @Author : INIC
  ******************/
  const showMinimumErrorMessage = (message) => {
    setMinDayErrorMessage(message);
  };

  /*******************
  @purpose : open calender and hide calender with time options set
  @Parameter : {}
  @Author : INIC
  ******************/
  const handleClickOpenCalendar = () => {
    setIshowCalendar(!isShowCalendar);
  };

  // Driven by isShowCalendar (rather than toggled imperatively in
  // handleClickOpenCalendar) so the body classes always match the actual
  // calendar state and are guaranteed removed on unmount - a plain
  // classList.toggle() call can drift out of sync (e.g. the component
  // unmounting via client-side navigation while the calendar is open) and
  // leave "model-active" (overflow: hidden) stuck on <body> across
  // subsequent pages, since Next.js never resets body classes on route change.
  useEffect(() => {
    document.body.classList.toggle("model-active", isShowCalendar);
    document.body.classList.toggle("vehicle-calendar-open", isShowCalendar);
    return () => {
      document.body.classList.remove("model-active");
      document.body.classList.remove("vehicle-calendar-open");
    };
  }, [isShowCalendar]);

  /*******************
   @purpose : select time as per scenario
   @Parameter : {}
   @Author : INIC
   ******************/
  {/*   useEffect(() => {
    if (startDateTimeOptions.length > 0) {
      let index = 0;
      if (startDate) {
        if (
          (startDate == endDate && isTodayDate(dateObj[0].startDate)) ||
          isTodayDate(dateObj[0].startDate)
        ) {
          if (startDateTimeOptions.length > 0) {
            index = startDateTimeOptions[0]["id"];
          } else {
            index = 0;
          }
        } else {
          if (startDateTimeOptions.length > 0) {
            index = startDateTimeOptions[2]["id"];
          } else {
            index = 0;
          }
        }
      }
      setStartTimeDefaultValue(index);
      if (endDate) {
        if (startDate == endDate) {
          let tempEndObj = [];
          startDateTimeOptions.forEach(function (row) {
            if (row.id > index) {
              tempEndObj.push(row);
            }
          });
          setEndDateTimeOptions(tempEndObj);
        } else {
          let tempObj = "";
          if (isWeekendDate(dateObj[0].endDate)) {
            tempObj = getTimeOptions("weekend");
          } else {
            tempObj = getTimeOptions("other");
          }
          setEndDateTimeOptions(tempObj);
        }
      }
    } else {
      setEndDateTimeOptions([]);
      setIsReserveEnable(true);
    }
  }, [startDateTimeOptions]); */}

  useEffect(() => {
    if (endDate) {
      if (startTimeDefaultValue == endTimeDefaultValue) {
        changeTimeBreakDown();
      }
    } else {
      setBreakDownObj({});
      setIsReserveEnable(true);
    }
  }, [endTimeDefaultValue]);

  useEffect(() => {
    changeTimeBreakDown();
  }, [endDate]);

  const changeTimeBreakDown = () => {
    if (!isFirstTimeLoad) {
      if (endDate) {
        commonBreakDown();
        setIsReserveEnable(false);

      } else {
        setBreakDownObj({});
        setIsReserveEnable(true);
      }
    }
  };

  /*******************
  @purpose : Set start options and end options
  @Parameter : {date}
  @Author : INIC
  ******************/
  const startTimeOptionsHandler = (dateObj) => {
    setIsFirstTimeLoad(false);
    // process on date
    let tempStartDateFlag = "";
    /*******************
      @purpose : start date and time selection login start here
      @Author : INIC
      ******************/
    // Today  login start here
    // if (isTodayDate(dateObj.startDate) && isWeekendDate(dateObj.startDate)) {
    //   tempStartDateFlag = "todayweekend";
    //   setStartDateTimeOptions(getTimeOptions(tempStartDateFlag));
    // } else if (isTodayDate(dateObj.startDate)) {
    //   tempStartDateFlag = "today";
    //   setStartDateTimeOptions(getTimeOptions(tempStartDateFlag));
    // }
    // // weekend login start here
    // else if (isWeekendDate(dateObj.startDate)) {
    //   tempStartDateFlag = "weekend";
    //   setStartDateTimeOptions(getTimeOptions(tempStartDateFlag));
    // }
    // // other day login start here
    // else {
    //   tempStartDateFlag = "other";
    //   setStartDateTimeOptions(getTimeOptions(tempStartDateFlag));
    // }
  };

  /*******************
  @purpose : redirect to vehical booking
  @Parameter : {}
  @Author : INIC
  ******************/
  const onClickHandler = async () => {
    if (breakDownObj.days >= vehicalDetailData?.vehicle?.minimum_days) {
      setLoaders(true);
      const start_date = moment(startDate).format("YYYY-MM-DD");
      const end_date = moment(endDate).format("YYYY-MM-DD");
      const startTime = startTimeDefaultValue
      const endTime = endTimeDefaultValue
      const res = await dispatch(
        getAvailableSlot(
          get_cookie("currentLocationId"),
          vehicalDetailData?.vehicle?.id,
          start_date,
          end_date, "submit", "", startTime?.replace(":00", ""), endTime.replace(":00", "")
        ))
      if (res && res?.common_vehicles?.length > 0 && res?.event === "submit") {

        const daterange = startDate + "|" + endDate;
        const timerange = startTimeDefaultValue + "|" + endTimeDefaultValue;
        const vSlug = vehicalDetailData?.vehicle?.slug;
        const brandId = vehicalDetailData?.vehicle?.brand_detail.id;
        const vId = vehicalDetailData?.vehicle?.id;

        set_cookie("brandId", brandId, 1);
        set_cookie("vId", vId, 1);
        set_cookie("vSlug", vSlug, 1);
        set_cookie("daterange", daterange, 1);
        set_cookie("timerange", timerange, 1);
        set_cookie("vehicleBookingBackUrl", router.asPath, 1);
        remove_cookie("selectedLocationDraft");
        setMinDayErrorMessage("");
        //as per client reqirements we add delay to show full loader
        setTimeout(() => {
          router.push("/vehiclebooking");
        }, 1000);
      } else {
        setLoaders(false)
        setNoVehicleError("No vehicle available for this date, please select a different date range.");
      }
    } else {
      setLoaders(false)
      setMinDayErrorMessage(
        minimumDayErrorMessage(vehicalDetailData?.vehicle?.minimum_days)
      );
    }
  };

  /*******************
  @purpose : call breakdown function
  @Parameter : {}
  @Author : INIC
  ******************/
  const commonBreakDown = () => {
    if (endDate && startDate) {
      if (!isFirstTimeLoad) {
        const obj = breakDown(
          vehicalDetailData?.vehicle,
          dateObj,
          startTimeDefaultValue,
          endTimeDefaultValue,
          user?.userInfo?.date_of_birth,
          globalSetting
        );
        setBreakDownObj(obj);
      }
    } else {
      setBreakDownObj({});
      setIsReserveEnable(true);
    }
  };

  // Login modal property
  const [show, setShow] = useState(false);
  const handleShow = () => {
    dispatch(setShowOtpBlock(false));
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };

  /*******************
  @purpose : save vehicle as favorite
  @Parameter : {}
  @Author : INIC
  ******************/
  const saveHandler = () => {
    setClickOnFavorite(1);
    if (user?.token) {
      favoriteApi();
    } else {
      //show login popup
      handleShow();
    }
  };

  /*******************
  @purpose : user token
  @Parameter : {}
  @Author : INIC
  ******************/
  useEffect(() => {
    if (user?.token && clickOnFavorite) {
      // call vehicle detail api
      dispatch(
        getVehicalDetailData(
          vehicalDetailData?.vehicle?.location_id,
          vehicalDetailData?.vehicle?.slug,
          vehicalDetailData?.vehicle?.brand_detail?.slug,
          vehicalDetailData?.vehicle?.category_detail?.slug
        )
      ).then((res) => {
        setClickOnFavorite(0);
        if (res?.vehicle?.is_favourite) {
          setFavId(res?.vehicle?.is_favourite);
          setFavUnFavMessage(ALREADY_SAVED_WISHLIST);
          setAddOnClass("show");
          setTimeout(() => {
            setAddOnClass("hide");
          }, 1000);
        } else {
          favoriteApi();
        }
      });
    }
  }, [user?.token]);

  const favoriteApi = () => {
    const vId = vehicalDetailData?.vehicle?.id;
    let favorite = { vehicle_id: vId };
    dispatch(addUserFavorite(favorite)).then((res) => {
      if (res.success) {
        setFavId(res?.data?.is_favourite);
        if (res?.data?.is_favourite) {
          setFavUnFavMessage(SAVED_WISHLIST);
          setIsSaved(true);
        } else {
          setFavUnFavMessage(REMOVED_WISHLIST);
          setIsSaved(false);
        }
        setAddOnClass("show");
        setTimeout(() => {
          setAddOnClass("hide");
        }, 1000);
      }
    });
  };

  // share popup property
  const [showForSharePopup, setShowForSharePopup] = useState(false);
  const handleCloseForSharePopup = () => setShowForSharePopup(false);
  const handleShowForSharePopup = () => setShowForSharePopup(true);

  let shareClickCount = useSelector((state) => state?.common?.shareClickCount);
  useEffect(() => {
    if (shareClickCount) {
      handleShowForSharePopup();
    }
  }, [shareClickCount]);

  const executeOnClick = (isExpanded) => {
    if (!isExpanded) {
      window.scrollTo(0, 1100);
    }
  };

  // set youtube video url
  const [youtubeUrl, setYoutubeUrl] = useState("");
  useEffect(() => {
    let url = "";
    const urlStr = vehicalDetailData?.vehicle?.mobile_video_url;
    const code = urlStr ? urlStr?.split("/")?.pop() : null;
    if (code) {
      url = "https://www.youtube.com/embed/" + code;
      setYoutubeUrl(url);
    } else {
      setYoutubeUrl("");
    }
  }, [vehicalDetailData?.vehicle?.mobile_video_url]);

  const renderTooltip = () => {
    if (showInfoModal) {
      return (
        <span className="d-flex mb-2">
          {`A minimum of ${minDays} ${dayLabel} rental is required for this vehicle. Early returns are allowed, however, the rental fee for the full ${minDays} ${dayLabel} will be incurred.`}
        </span>
      );
    } else if (securityDepositModal) {
      return (
        <>
          <div className="space-mb-12"> <span className="text-dark-popup">Clients aged 25+</span>with verifiable full coverage insurance and a valid credit card: <span className="text-dark-popup">${formatMoney(vehicalDetailData?.vehicle?.security_deposit_admin)}.</span> </div>
          <div className="space-mb-12"> <span className="text-dark-popup">Clients under 25</span>with mandatory full coverage insurance and a valid credit card: <span className="text-dark-popup">${formatMoney(vehicalDetailData?.vehicle?.security_deposit_under_age)}.</span></div>
          <div className="space-mb-12"> <strong className="text-dark-popup">International clients aged 25+</strong>without verifiable full coverage insurance: <strong className="text-dark-popup">${formatMoney(vehicalDetailData?.vehicle?.security_deposit_without_cdw)}.</strong>(Collision Damage Waiver (CDW) must be purchased separately and is subject to approval.)</div>
          <div className="space-mb-12">We will place a temporary hold for the security deposit amount on your credit card. This hold will be fully released upon the return of the vehicle, provided there is no damage or additional charges.</div>
          <div className="space-mb-12"><span className="text-dark-popup">Please Note:</span>Deposit amounts may vary based on rental duration and additional factors. The final deposit amount will be confirmed after reservation and document submission.</div>
        </>
      );
    }
    return null;
  };

  useEffect(() => {
    if (window.screen.width > 740) {
      setIsMobileScreen(false);
    } else {
      setIsMobileScreen(true);
    }
  }, [isMobileScreen]);


  return (
    <>
      {/* Car details section : Start */}
      <section className={`car-details ${isMobileApp === "yes" ? "pt-0" : ""}`}>
        <div className="custom-container">
          <div className="d-none d-lg-flex justify-content-between car-details-head">
            <div className="d-flex align-items-center car-name">
              <h1 className="content-title mb-0">
                {vehicalDetailData?.vehicle?.name_with_brand} Rental
              </h1>
            </div>
          </div>
          <div className="d-none d-lg-flex justify-content-between align-items-center mb-3">
            <Breadcrumbs
              brandCategorydetail={vehicalDetailData?.vehicle?.brand_detail}
              vehicleName={vehicalDetailData?.vehicle?.name}
              slug1={slug1}
              slug2={slug2}
              vehicleSlug={vehicalDetailData?.vehicle?.brand_detail?.slug}
              categoryDetail={vehicalDetailData?.vehicle?.category_detail}
            />

            <div className="sharing-group">
              <Button variant="outline-light">
                <div onClick={handleShowForSharePopup}>
                  <span className="icon icon-export mr-10 font-14"></span>
                  <span className="text-decoration-underline shares-text">
                    Share
                  </span>
                </div>
              </Button>
              <Button variant="outline-light" onClick={() => saveHandler()}>
                <span className="icon">
                  <svg
                    className={`${
                      favId ? "icon-fill-heart text-black" : "icon-empty-heart"
                    }`}
                    viewBox="0 0 32 32"
                    aria-hidden="true"
                    role="presentation"
                    focusable="false"
                  >
                    <path d="m16 28c7-4.733 14-10 14-17 0-1.792-.683-3.583-2.05-4.95-1.367-1.366-3.158-2.05-4.95-2.05-1.791 0-3.583.684-4.949 2.05l-2.051 2.051-2.05-2.051c-1.367-1.366-3.158-2.05-4.95-2.05-1.791 0-3.583.684-4.949 2.05-1.367 1.367-2.051 3.158-2.051 4.95 0 7 7 12.267 14 17z"></path>
                  </svg>
                </span>
                <span className="text-decoration-underline shares-text">
                  {favId ? "Saved" : "Save"}
                </span>
              </Button>
            </div>
          </div>

          <div className="d-flex justify-content-between flex-column flex-lg-row car-detail-slider exotic-car">
            {/* Left content : Start */}
            <div className="left-content">
              {/* Car slider */}
              <CarSlider
                key={vehicalDetailData?.vehicle?.id}
                vehicalDetailData={vehicalDetailData}
                saveHandler={saveHandler}
                favId={favId}
              />
              {/* Mobile Heading */}
              <div className="d-block d-lg-none mobile-car-heading">
                <Breadcrumbs
                  brandCategorydetail={vehicalDetailData?.vehicle?.brand_detail}
                  vehicleName={vehicalDetailData?.vehicle?.name}
                  slug1={slug1}
                  slug2={slug2}
                  vehicleSlug={vehicalDetailData?.vehicle?.brand_detail?.slug}
                  categoryDetail={vehicalDetailData?.vehicle?.category_detail}
                />
                {isMobileApp !== "yes" && (
                  <div className="d-flex align-items-start align-items-md-center flex-column flex-md-row car-name">
                    <h1 className="content-title mb-0">
                      {vehicalDetailData?.vehicle?.name_with_brand} Rental
                    </h1>
                    {/* <Badge bg="primary" className="discount-badge">
                    Get Special Discount
                  </Badge> */}
                  </div>
                )}
                {/* {vehicalDetailData?.vehicle?.availability == 2 && (
                  <div className="d-flex align-items-start align-items-md-center flex-column flex-md-row car-name">
                    <p className="content-title mb-0 mt-4 ff-hel-reg font-30">
                      Temporarily Unavailable
                    </p>
                  </div>
                )} */}
              </div>
              {/* Discount box */}
              <div className="d-flex flex-column flex-md-row discount-list">
                <div className="d-flex align-items-center offer-card">
                  <span className="icon icon-route1"></span>
                  <ul className="mb-0 offer-content list-unstyled">
                    {vehicalDetailData?.vehicle?.milesday && (
                      <li>
                        <span className="dot"></span>
                        <span className="text">
                          {vehicalDetailData?.vehicle?.milesday} free miles a
                          day
                        </span>
                      </li>
                    )}
                    {vehicalDetailData?.vehicle?.extramile && (
                      <li>
                        <span className="dot"></span>
                        <span className="text">
                          ${vehicalDetailData?.vehicle?.extramile} per extra
                          mile
                        </span>
                      </li>
                    )}
                  </ul>
                </div>
                <div className="d-flex align-items-center offer-card">
                  <span className="icon icon-dollar-square1"></span>
                  <ul className="mb-0 offer-content list-unstyled">
                    {vehicalDetailData?.vehicle?.security_deposit && (
                      <li>
                        <span className="dot"></span>

                        <span className="text">
                          Security Deposit:{" "}
                          {vehicalDetailData?.vehicle?.security_deposit}
                        </span>
                        {isMobileScreen && (
                          <div className="tooltip-wrapper">
                          <img
                            src={tooltip}
                            alt="Tooltip"
                            onClick={() => handleInfoShow("deposit")}
                          />
                          </div>
                        )}
                        {!isMobileScreen && (
                          <ManualTooltip
                            content={
                              <div className="tooltip-modal">
                                <div className="security-block common-modal-tooltip">
                                  <div className="breakdown-modal flex-column">
                                    <div className="modal-header common-tooltip-header">
                                      <h3 className="modal-title tooltip-title">
                                        Security Deposit
                                      </h3>
                                    </div>
                                    <div className="common-seprarte tootltip-seprate mb-3">
                                      <div className="space-mb-12">
                                        {" "}
                                        <span className="text-dark-popup">
                                          Clients aged 25+
                                        </span>
                                        with verifiable full coverage insurance
                                        and a valid credit card:{" "}
                                        <span className="text-dark-popup">
                                          $
                                          {formatMoney(
                                            vehicalDetailData?.vehicle
                                              ?.security_deposit_admin
                                          )}
                                          .
                                        </span>{" "}
                                      </div>
                                      <div className="space-mb-12">
                                        {" "}
                                        <span className="text-dark-popup">
                                          Clients under 25
                                        </span>
                                        with mandatory full coverage insurance
                                        and a valid credit card:{" "}
                                        <span className="text-dark-popup">
                                          $
                                          {formatMoney(
                                            vehicalDetailData?.vehicle
                                              ?.security_deposit_under_age
                                          )}
                                          .
                                        </span>
                                      </div>
                                      <div className="space-mb-12">
                                        {" "}
                                        <strong className="text-dark-popup">
                                          International clients aged 25+
                                        </strong>
                                        without verifiable full coverage
                                        insurance:{" "}
                                        <strong className="text-dark-popup">
                                          $
                                          {formatMoney(
                                            vehicalDetailData?.vehicle
                                              ?.security_deposit_without_cdw
                                          )}
                                          .
                                        </strong>
                                        (Collision Damage Waiver (CDW) must be
                                        purchased separately and is subject to
                                        approval.)
                                      </div>
                                      <div className="space-mb-12">
                                        We will place a temporary hold for the
                                        security deposit amount on your credit
                                        card. This hold will be fully released
                                        upon the return of the vehicle, provided
                                        there is no damage or additional
                                        charges.
                                      </div>
                                      <div className="space-mb-12">
                                        <span className="text-dark-popup">
                                          Please Note:
                                        </span>
                                        Deposit amounts may vary based on rental
                                        duration and additional factors. The
                                        final deposit amount will be confirmed
                                        after reservation and document
                                        submission.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            trigger="hover"
                          >
                            <img
                              src={tooltip}
                              alt="Tooltip"
                              style={{ cursor: "pointer" }}
                            />
                          </ManualTooltip>
                        )}
                      </li>
                    )}
                    <li className="d-flex align-items-center">
                      <span className="dot"></span>
                      <span className="text">
                        Minimum Days:{" "}
                        {vehicalDetailData?.vehicle?.minimum_days
                          ? vehicalDetailData?.vehicle?.minimum_days
                          : "1"}{" "}
                      </span>
                      {isMobileScreen && (
                        <div className="tooltip-wrapper">
                        <img
                          src={tooltip}
                          alt="Tooltip"
                          onClick={() => handleInfoShow("minimumDays")}
                        />
                        </div>
                      )}
                      {!isMobileScreen && (
                        <ManualTooltip
                          content={
                            <div className="tooltip-modal">
                              <div className="common-modal-tooltip">
                                <div className="common-tooltip-header">
                                  <h3 className="tooltip-title">
                                    Minimum Rental Period
                                  </h3>
                                </div>
                                <div className="tootltip-seprate">
                                  <span class="d-flex mb-2">
                                  {`A minimum of ${minDays} ${dayLabel} rental is required for this vehicle. Early returns are allowed, however, the rental fee for the full ${minDays} ${dayLabel} will be incurred.`}
                                  </span>
                                </div>
                              </div>
                            </div>
                          }
                          trigger="hover"
                        >
                          <img
                            src={tooltip}
                            alt="Tooltip"
                            style={{ cursor: "pointer" }}
                          />
                        </ManualTooltip>
                      )}
                    </li>
                    {/* {vehicalDetailData?.milesday && (
                      <li>
                        {vehicalDetailData?.milesday} Free Miles / Day |
                        <b> ${vehicalDetailData?.extramile}</b> / Extra Mile
                      </li>
                    )}
                    {vehicalDetailData?.security_deposit && (
                      <li>
                        Security Deposit: <b>{vehicalDetailData?.security_deposit} </b>
                      </li>
                    )}
                    {vehicalDetailData?.minimum_days > 1 && (
                      <li>
                        Minimum Days: <b>{vehicalDetailData?.minimum_days} </b>
                      </li>
                    )} */}
                  </ul>
                </div>
              </div>
              {/* Features List */}
              <ul className="list-unstyled d-flex justify-content-around align-items-center car-specification">
                <li>
                  <span className="icon icon-engine-new"></span>
                  <div className="d-flex flex-column align-items-center align-items-sm-start">
                    <b>Engine</b>
                    <em>{" " + vehicalDetailData?.vehicle?.engine}</em>
                  </div>
                </li>
                <li>
                  <span className="icon icon-car-seat"></span>
                  <div className="d-flex flex-column align-items-center align-items-sm-start">
                    <b>Seats</b>
                    <em>{" " + vehicalDetailData?.vehicle?.seats}</em>
                  </div>
                </li>
                <li>
                  <span className="icon icon-mph-new"></span>
                  <div className="d-flex flex-column align-items-center align-items-sm-start">
                    <b>0-60 mph</b>
                    <em>{" " + vehicalDetailData?.vehicle?.six}</em>
                  </div>
                </li>
                <li>
                  <span className="icon icon-msrp"></span>
                  <div className="d-flex flex-column align-items-center align-items-sm-start">
                    <b>MSRP</b>
                    <em>{" " + vehicalDetailData?.vehicle?.msrp}</em>
                  </div>
                </li>
              </ul>
              <div className="d-block d-lg-none car-offer-blck-mobile">
                <OfferCard
                  vehicalDetailData={vehicalDetailData?.vehicle}
                  isMobileScreen={isMobileScreen}
                />
              </div>

              {/* Car description */}
              {vehicalDetailData?.vehicle?.desktop_video &&
                !isMobileScreen &&
                vehicalDetailData?.vehicle?.desktop_video_thumbnail && (
                  <>
                    <div className="exotic-wrapper position-relative">
                      <div className="section-heading detail-heading">
                        <h3 className="mb-0">The Experience</h3>
                      </div>
                      <div className="exotic-video car-detail-video">
                        <div className="video-wrap">
                          <video
                            width="320"
                            height="240"
                            poster={
                              vehicalDetailData?.vehicle
                                ?.desktop_video_thumbnail
                            }
                            controls
                          >
                            <source
                              src={vehicalDetailData?.vehicle?.desktop_video}
                              type="video/mp4"
                            />
                          </video>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              {vehicalDetailData?.vehicle?.mobile_video &&
                isMobileScreen &&
                vehicalDetailData?.vehicle?.mobile_video_thumbnail && (
                  <>
                    <div className="exotic-wrapper position-relative">
                      <div className="section-heading">
                        <h3 className="mb-0">The Experience</h3>
                      </div>
                      <div className="exotic-video">
                        <div className="video-wrap">
                          <video
                            width="320"
                            height="240"
                            poster={
                              vehicalDetailData?.vehicle?.mobile_video_thumbnail
                            }
                            controls
                          >
                            <source
                              src={vehicalDetailData?.vehicle?.mobile_video}
                              type="video/mp4"
                            />
                          </video>
                        </div>
                      </div>
                    </div>
                  </>
                )}

              {isMobileApp !== "yes" && (
                <h2
                  className="mb-0 mb-sm-4 cbn-title mt-sm-0 dec-title"
                  id="description"
                >
                  Rent a {vehicalDetailData?.vehicle?.name_with_brand}
                </h2>
              )}
              {/* {vehicalDetailData?.vehicle?.mobile_video_url && (
                <div className="exotic-video car-detail-video">
                  <div className="video-wrap">
                    <YouTubeComp
                      videoUrl={vehicalDetailData?.vehicle?.mobile_video_url}
                    />
                  </div>
                </div>
              )} */}
              <div className="car-description-list">
                {vehicalDetailData?.vehicle?.description && (
                  <div className="car-description" id="descriptionParent">
                    <h5 onClick={() => handleClick(1)}>Description</h5>

                    <div className="description">
                      <ShowMore
                        lines={3}
                        className="d-none d-sm-block"
                        more="Show More"
                        less="Show Less"
                        onClick={executeOnClick}
                        anchorClass="d-none d-sm-block"
                      >
                        {/* {vehicalDetailData?.vehicle?.description.includes(
                          "br>"
                        ) ? (
                          ReactHtmlParser(
                            vehicalDetailData?.vehicle?.description
                          )
                        ) : (
                          <NewLineToBr>
                            {vehicalDetailData?.vehicle?.description}
                          </NewLineToBr>
                        )} */}

                        {ReactHtmlParser(
                          vehicalDetailData?.vehicle?.description
                        )}
                      </ShowMore>

                      <span className="d-block d-sm-none">
                        {/* {vehicalDetailData?.vehicle?.description.includes(
                          "br>"
                        ) ? (
                          ReactHtmlParser(
                            vehicalDetailData?.vehicle?.description
                          )
                        ) : (
                          <NewLineToBr>
                            {vehicalDetailData?.vehicle?.description}
                          </NewLineToBr>
                        )} */}
                        {ReactHtmlParser(
                          vehicalDetailData?.vehicle?.description
                        )}
                      </span>
                    </div>
                  </div>
                )}
                {vehicalDetailData?.vehicle?.features && (
                  <div className="car-description" id="featureParent">
                    <h5 onClick={() => handleClick(2)}>Features</h5>

                    <div className="description">
                      <ShowMore
                        lines={4}
                        className="d-none d-sm-block"
                        more="Show More"
                        less="Show Less"
                        onClick={executeOnClick}
                        anchorClass="d-none d-sm-block"
                      >
                        {/* {vehicalDetailData?.vehicle?.features.includes(
                          "br>"
                        ) ? (
                          ReactHtmlParser(vehicalDetailData?.vehicle?.features)
                        ) : (
                          <NewLineToBr>
                            vehicalDetailData?.vehicle?.features
                          </NewLineToBr>
                        )} */}
                        {ReactHtmlParser(vehicalDetailData?.vehicle?.features)}
                      </ShowMore>
                      <span className="d-block d-sm-none">
                        {/* {vehicalDetailData?.vehicle?.features.includes(
                          "br>"
                        ) ? (
                          ReactHtmlParser(vehicalDetailData?.vehicle?.features)
                        ) : (
                          <NewLineToBr>
                            vehicalDetailData?.vehicle?.features
                          </NewLineToBr>
                        )} */}
                        {ReactHtmlParser(vehicalDetailData?.vehicle?.features)}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* Left content : End */}

            {/* Right content : Start */}
            <div className="right-content d-none d-lg-block">
              <div className="inner-wrap ln-normal">
                <CarPriceBox
                  vehicalDetailData={vehicalDetailData?.vehicle}
                  globalSetting={globalSetting}
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  startTimeDefaultValue={startTimeDefaultValue}
                  endTimeDefaultValue={endTimeDefaultValue}
                  setStartTimeDefaultValue={setStartTimeDefaultValue}
                  setEndTimeDefaultValue={setEndTimeDefaultValue}
                />

                {/* Offer list */}
                <OfferCard
                  vehicalDetailData={vehicalDetailData?.vehicle}
                  isMobileScreen={isMobileScreen}
                />
              </div>
            </div>
            {/* Right content : End */}
          </div>
        </div>
      </section>
      {/* Car details section : End */}

      {/* Section Divider  */}
      <div className="custom-container">
        <div className="section-divider wb-section"></div>
      </div>

      {vehicalDetailData?.related_vehicle &&
        vehicalDetailData?.related_vehicle?.length > 0 && (
          <section
            className={`may-also-like ${
              isMobileApp ? "page-bottom-space" : ""
            }`}
          >
            <div className="custom-container">
              <div className="section-heading detail-heading">
                <h3 className="mb-0">You may also like</h3>
              </div>
            </div>

            {/* You may also like slider : Start */}
            <div className="also-like-card">
              <div className="row">
                {vehicalDetailData?.related_vehicle.map(
                  (row, index) =>
                    index < 3 && (
                      <div className="col-md-4" key={index} id={index}>
                        <div className="slider-boxes-inner">
                          <Link
                            href={
                              "/" +
                              slug1 +
                              "/" +
                              slug2 +
                              "/" +
                              row.brand_detail.slug +
                              "/" +
                              row.category_detail.slug +
                              "/" +
                              row.slug +
                              "/" +
                              row.slug_id
                            }
                            key={index}
                          >
                            <a>
                              <div className="slider-box-img drive-car-dp">
                                <picture>
                                  <img
                                    src={row?.primary_image?.image?.main}
                                    alt={row?.primary_image?.alt}
                                    className="img-fluid drive-car-dp"
                                  />
                                </picture>

                                {
                                  // <picture>
                                  //   <source
                                  //     srcSet={change_extension(
                                  //       row.primary_image.image.main
                                  //     )}
                                  //     type="image/webp"
                                  //     alt={row?.primary_image?.alt}
                                  //   />
                                  //   <source
                                  //     srcSet={row.primary_image.image.main}
                                  //     type="image/jpg"
                                  //     alt={row?.primary_image?.alt}
                                  //   ></source>
                                  //   <img
                                  //     src={row.primary_image.image.main}
                                  //     className="img-fluid drive-car-dp"
                                  //     alt={row?.primary_image?.alt}
                                  //     // onError={(e) => {
                                  //     //   e.target.onerror = null;
                                  //     //   e.target.src =
                                  //     //     "/assets/images/youMayLikePlaceholder.jpg";
                                  //     // }}
                                  //   />
                                  // </picture>
                                  // <Image
                                  //   src={row.primary_image.image.main}
                                  //   width={466}
                                  //   height={285}
                                  //   objectFit="cover"
                                  //   className="img-fluid drive-car-dp"
                                  //   alt={row?.primary_image?.alt}
                                  //   title={row?.primary_image?.alt}
                                  //   priority
                                  // />
                                }
                              </div>
                            </a>
                          </Link>

                          <div className="slider-box-details">
                            <h5 className="d-flex flex-column mb-0 overflow-hidden">
                              {/* <div className="d-flex align-items-center slider-brand-name">
                              </div> */}
                              <span className="slider-cbn text-uppercase font-16 ff-hel-reg text-black">
                                {row?.brand_detail?.title}
                              </span>
                              <span className="slider-cbmn font-22 ff-hel-reg text-black text-truncate">
                                {row?.name}
                              </span>
                            </h5>
                            <div className="d-flex flex-column car-price">
                              {/* <span className='font-24 text-right ff-hel-med discount-price'>${row?.day}</span>
                        <small className='font-16'><del>${row.real_price}</del> / day</small> */}

                              {/* <Badge bg="primary" className="discount-badge">
                                Get Special Discount
                              </Badge> */}

                              <span className="d-flex flex-column ff-hel-reg text-black text-right card-price">
                                {row?.real_price ? (
                                  <>
                                    <span className="text-primary ff-hel-med">
                                      ${row?.day}
                                    </span>
                                    <small className="text-black font-16">
                                      {" "}
                                      {row?.real_price && (
                                        <del>${row?.real_price}</del>
                                      )}
                                      /day
                                    </small>
                                  </>
                                ) : (
                                  <>
                                    <span className="text-black ff-hel-med">
                                      ${row?.day}
                                    </span>
                                    <small className="text-black font-16">
                                      per day
                                    </small>
                                  </>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
            {/* You may also like slider : End */}
          </section>
        )}

      {!startDate || !startDateMobile || !endDateMobile ? (
        <div className="d-flex d-lg-none justify-content-between align-items-center bottom-filed safe-area-bottom">
          <span className="d-flex align-items-start flex-column car-price">
            {vehicalDetailData?.vehicle?.real_price ? (
              <span className="discounted_rate font-20 ff-hel-med text-dark">
                ${vehicalDetailData?.vehicle?.day}
              </span>
            ) : (
              <span className="discounted_rate font-20 ff-hel-med text-dark">
                ${vehicalDetailData?.vehicle?.day}
              </span>
            )}

            {vehicalDetailData?.vehicle?.real_price ? (
              <>
                <small className="text-dark">
                  <del>${vehicalDetailData?.vehicle?.real_price}</del>/day
                </small>
              </>
            ) : (
              <>
                <small className="text-black">per day</small>
              </>
            )}
          </span>
          {/* <span className="text-danger font-12 ff-hel-med breakdown-error">
            {minDayErrorMessage}
          </span> */}
          <Button
            variant="primary"
            className="w-100 btn-primary"
            onClick={handleClickOpenCalendar}
          >
            Select Dates
          </Button>
        </div>
      ) : (
        <div className="d-flex d-lg-none justify-content-between align-items-center bottom-filed safe-area-bottom">
          <span className="d-flex align-items-start flex-column car-price">
            {breakDownObj?.totalCharge && (
              <span
                className="discounted_rate font-20 ff-hel-med"
                onClick={handleShowBreakDown}
              >
                ${formatMoney(breakDownObj?.totalCharge)} <sub>Total</sub>
              </span>
            )}
            <small
              onClick={handleClickOpenCalendar}
              className="text-primary sm-underline date-select"
            >
              {startDateMobile} - {endDateMobile}
            </small>
          </span>
          {/* <span className="text-danger font-12 ff-hel-med breakdown-error">
            {minDayErrorMessage}
          </span> */}
          {minDayErrorMessage ? (
            <Button
              variant="primary"
              className="w-100 btn-primary"
              onClick={handleClickOpenCalendar}
            >
              Select Dates
            </Button>
          ) : (
            <Button
              variant="primary"
              className={`w-100 btn-primary gtstep-mobile ${
                loaders ? "btn-loader-size-s" : ""
              }`}
              onClick={onClickHandler}
              disabled={loaders || isReserveEnable}
            >
              {loaders ? <ButtonLoader /> : "Next"}
            </Button>
          )}
        </div>
      )}
      {/* Date Range */}
      {isShowCalendar ? (
        <DateRangePicker
          dateObj={dateObj}
          setDateObj={setDateObj}
          setEndDateMobile={setEndDateMobile}
          setStartDateMobile={setStartDateMobile}
          handleClickOpenCalendar={handleClickOpenCalendar}
          setStartEndDateOnChange={setStartEndDateOnChange}
          startTimeOptionsHandler={startTimeOptionsHandler}
          isFirstTimeLoad={isFirstTimeLoad}
          tempDirections="horizontal"
          tempScroll={{ enabled: false }}
          showMinimumErrorMessage={showMinimumErrorMessage}
          minimumDay={minimumDay}
          selectedStartDate={startDate}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          vehicleId={vehicalDetailData?.vehicle?.id}
          setStartTimeDefaultValue={setStartTimeDefaultValue}
          setEndTimeDefaultValue={setStartTimeDefaultValue}
          isVehcileDetailsPage={true}
          minDayError={minDayErrorMessage}
          isAvailable={vehicalDetailData?.vehicle?.availability !== 1}
        />
      ) : (
        ""
      )}

      {/* break down popup */}
      <BreakDownModal
        showModal={showModal}
        handleClose={handleCloseBreakDown}
        breakDownObj={breakDownObj}
        isEmailMeShow={false}
        isPromoCodeShow={false}
      />
      {(showInfoModal || securityDepositModal) && (
        <CommonInfoModal
          showModal={true}
          handleClose={handleInfoClose}
          infoDetails={renderTooltip()}
          title={showInfoModal ? "Minimum Rental Period" : "Security Deposit"}
        />
      )}

      {/* Login modal */}
      <LoginModal show={show} handleClose={handleClose} />

      {/* success popup for favouirty and unfavority */}
      <SuccessPopup
        addOnClass={addOnClass}
        message={favUnFavMessage}
        error={!isSaved}
      />

      <SocialShareModel
        iconClass="icon icon-export mr-10 font-14"
        data={vehicalDetailData}
        flag="vehicle"
        show={showForSharePopup}
        handleClose={handleCloseForSharePopup}
      />
      {/*    <MainModal
        showHandler={showMessageModal}
        hideHandler={setShowMessageModal}
        body="To proceed with the reservation, please log in to your account or sign up if you don't have one. Thank you!"
        modalTitle="Login Required"
      /> */}
    </>
  );
};

export default Vehicle;
